import type * as React from 'react';
import {useState} from 'react';
import AuthHandler from '../../components/Auth/AuthHandler';
import type {IdCard} from '../../utils/IdCard';
import DownloadIdDialog from './DownloadIdDialog';

type Props = {
    open: boolean;
    onClose: () => void;
    onDownloadSuccess: (idCard: IdCard) => void;
};

const DownloadIdController: React.FC<Props> = ({open, onClose, onDownloadSuccess}: Props) => {
    const [authenticated, setAuthenticated] = useState(false);

    return (
        <>
            <DownloadIdDialog
                open={open && authenticated}
                onClose={onClose}
                onDownloadSuccess={onDownloadSuccess}
            />

            <AuthHandler
                requireAuth={open}
                requiredTokenLifetime={60}
                onClose={onClose}
                onAuth={() => {
                    setAuthenticated(true);
                }}
                onExpire={() => {
                    setAuthenticated(false);
                    onClose();
                }}
            />
        </>
    );
};

export default DownloadIdController;
